import AdminGuard from "components/AdminGuard";
import GuestGuard from "components/GuestGuard";
import LoadingFullScreen from "components/LoadingFullScreen";
import ROUTERS_PATHS, { deMergeRoute } from "consts/router-paths";
import AdminLayout from "layouts/AdminLayout";
import MainLayout from "layouts/MainLayout";
import React, { Fragment, lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

export interface IRoutesState {
  exact?: boolean;
  path?: string;
  guard?: React.FC<{
    children: React.ReactNode;
    routes?: IRoutesState[];
  }>;
  layout?: React.FC<any>;
  roles?: string[];
  component?: any;
  disableLayout?: boolean;
  routes?: IRoutesState[];
}

export const renderRoutes = (routes: IRoutesState[]) => (
  <Suspense fallback={<LoadingFullScreen />}>
    <Routes>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Component = route.component;
        return (
          <Route
            key={i}
            path={route.path}
            element={
              <Guard routes={routes}>
                <Layout>{route.routes ? renderRoutes(route.routes) : <Component />}</Layout>
              </Guard>
            }
          />
        );
      })}
    </Routes>
  </Suspense>
);

const routes: IRoutesState[] = [
  {
    path: ROUTERS_PATHS.AUTHORIZATION,
    component: lazy(() => import("pages/AuthorizationView")),
  },
  {
    path: ROUTERS_PATHS.ADMIN,
    layout: AdminLayout,
    guard: AdminGuard,
    routes: [
      {
        path: deMergeRoute(`${ROUTERS_PATHS.ADMIN_DASHBOARD}/:type`),
        component: lazy(() => import("pages/Admin/Home")),
      },
      // {
      //   path: deMergeRoute(ROUTERS_PATHS.CREATE_ARTICLE),
      //   component: lazy(() => import("pages/Admin/CreateArticle"))
      // },
      {
        path: deMergeRoute(`${ROUTERS_PATHS.CREATE_TOPIC}/:id`),
        component: lazy(() => import("pages/Admin/AddEditTopic")),
      },
      {
        path: deMergeRoute(`${ROUTERS_PATHS.CREATE_TOPIC}`),
        component: lazy(() => import("pages/Admin/AddEditTopic")),
      },
      // {
      //   path: deMergeRoute(`${ROUTERS_PATHS.CREATE_ARTICLE}/:id`),
      //   component: lazy(() => import("pages/Admin/CreateArticle"))
      // },
      {
        path: deMergeRoute(ROUTERS_PATHS.CREATE_CATEGORY),
        component: lazy(() => import("pages/Admin/CreateCategory")),
      },
      {
        path: deMergeRoute(ROUTERS_PATHS.CREATE_SUBCATEGORY),
        component: lazy(() => import("pages/Admin/CreateCategory")),
      },
      {
        path: deMergeRoute(ROUTERS_PATHS.EMAIL_TEMPLATE),
        component: lazy(() => import("pages/Admin/EmailTemplate")),
      },
      {
        path: deMergeRoute(ROUTERS_PATHS.ROLE),
        component: lazy(() => import("pages/Admin/Role")),
      },
      {
        path: deMergeRoute(ROUTERS_PATHS.ADVANCED_SEARCH),
        component: lazy(() => import("pages/Admin/AdvancedSearch/index")),
      },
      {
        path: deMergeRoute(ROUTERS_PATHS.FEEDBACK),
        component: lazy(() => import("pages/Admin/Feedback")),
      },
      {
        path: deMergeRoute(ROUTERS_PATHS.REVIEW),
        component: lazy(() => import("pages/Admin/Reviews")),
      },
      {
        path: deMergeRoute(`${ROUTERS_PATHS.EDIT_REVIEW}/:id`),
        component: lazy(() => import("pages/Admin/Reviews/components/DetailReview")),
      },
      {
        path: deMergeRoute(ROUTERS_PATHS.ANALYTICS),
        component: lazy(() => import("pages/Admin/Analistics")),
      },
      {
        path: deMergeRoute(ROUTERS_PATHS.USER),
        component: lazy(() => import("pages/Admin/Users")),
      },
      {
        path: "*",
        component: () => <Navigate to={`${ROUTERS_PATHS.ADMIN_DASHBOARD}/category`} replace />,
      },
    ],
  },

  {
    path: ROUTERS_PATHS.ALL,
    layout: MainLayout,
    routes: [
      {
        path: ROUTERS_PATHS.DASHBOARD,
        component: lazy(() => import("pages/User/Dashboard")),
      },
      {
        path: ROUTERS_PATHS.TOPIC_DETAIL,
        component: lazy(() => import("pages/Topic")),
      },
      {
        path: ROUTERS_PATHS.SUBCATEGORIES,
        component: lazy(() => import("pages/SubCategories")),
      },
      {
        path: ROUTERS_PATHS.NOT_FOUND,
        component: lazy(() => import("pages/NotFound")),
      },
      {
        path: "*",
        component: () => <Navigate to={ROUTERS_PATHS.DASHBOARD} replace />,
      },
    ],
  },
];

export default routes;
